import React from "react";

const Seguimiento = ({ idEmpresa }) => {
  return (
    <div className="questionnaire-container">
      <h2>Cuestionario de Seguimiento</h2>
      <p>ID de Empresa: {idEmpresa}</p>
      <p>Aquí irá el formulario para el seguimiento del bienestar del usuario.</p>
    </div>
  );
};

export default Seguimiento;
